import React, { useEffect } from 'react';
import styled from 'styled-components';
import {
  OFFICE_ADDRESS,
  OFFICE_ADDRESS_KR,
  OFFICE_EMAIL_ADDRESS,
  OFFICE_FAX_NUMBER,
  OFFICE_TEL, PRESS_EMAIL_ADDRESS
} from 'utils/constants';
import { device } from 'utils/constants';
import Map from 'components/Map';

const Wrapper = styled.div`
  width: 100%;
  padding: 0 20px 40px;

  @media ${device.desktop} {
    padding: 0 20px 100px;
  }
`;

const Section = styled.section`
  display: block;
  margin-top: 50px;
  margin-bottom: 20px;

  @media ${device.desktop} {
    display: flex;
    margin-bottom: 40px;
  }
`;

const LeftWrapper = styled.div`
  width: 100%;
  @media ${device.desktop} {
    padding-right: 28px;
    width: 50%;
  }
`;

const InfoWrapper = styled.div`
  margin-bottom: 50px;
  line-height: 1.3;

  @media ${device.desktop} {
    margin-bottom: 80px;
  }
`;

const Title = styled.p`
  margin-bottom: 30px;
  font-size: 30px;
`;

const MapSection = styled.div`
  width: 100%;
  height: 60vw;
  margin-bottom: 36px;

  @media ${device.desktop} {
    margin-bottom: 0;
    height: 30vw;
  }
`;

const Info = styled.p`
  font-size: 12px;
  margin-bottom: 12px;
  line-height: 1.5;
  word-break: keep-all;
  
  span {
    display: inline-block;
    margin-right: 12px;
  }

  @media ${device.desktop} {
    margin-bottom: 14px;
    font-size: 13px;
  }
`;

const Mail = styled.a`
  display: inline-block;
  margin-bottom: 13px;
  font-size: 20px;
  font-style: italic;
  font-weight: bold;

  &:hover {
    font-weight: 500;
    transition: all 0.3s ease-in-out;
  }

  @media ${device.desktop} {
    margin-bottom: 17px;
    font-size: 18px;
  }
`;

const ContactInfo = styled.p`
  margin-bottom: 13px;
  font-size: 14px;

  @media ${device.desktop} {
    margin-bottom: 17px;
    font-size: 16px;
  }
`;

const ContactInfoDetail = styled.p`
  font-size: 12px;
  word-break: keep-all;
`;

const RightWrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;

  @media ${device.desktop} {
    width: 50%;
  }
`;

export default () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <Wrapper>
      {/* Map Section 캡쳐 -> 실제 map sdk 로 변경 */}
      <Section>
        <LeftWrapper>
          <MapSection>
            <Map />
          </MapSection>
        </LeftWrapper>

        <RightWrapper>

          <InfoWrapper>
            <Title>CONTACT.</Title>
            <Mail href={`mailto:${OFFICE_EMAIL_ADDRESS}`}>
              {OFFICE_EMAIL_ADDRESS}
            </Mail>
            <ContactInfo className='korean'>
              프로젝트 문의시 아래의 내용을 기재해서 보내주세요
            </ContactInfo>
            <ContactInfoDetail className='korean'>
              → 신청자 이름 or 상호/ 연락처 / 주소 / 시공 일정 / 공사내용
            </ContactInfoDetail>
          </InfoWrapper>

          <InfoWrapper>
            <Info className='korean'>{OFFICE_ADDRESS_KR}</Info>
            <Info>{OFFICE_ADDRESS}</Info>
            <Info>{OFFICE_TEL}</Info>
            <Info>{OFFICE_FAX_NUMBER}</Info>
            <Info>E. {OFFICE_EMAIL_ADDRESS}</Info>
            <Info>P. {PRESS_EMAIL_ADDRESS}</Info>
          </InfoWrapper>
        </RightWrapper>
      </Section>
    </Wrapper>
  );
};
